// Exports
export default {
	"container": "container_umLho",
	"text": "text_fPlf9",
	"loader": "loader_M5CZj"
};
